module.exports = __webpack_public_path__ + "assets/img/12.e5b89712.png";